module.exports = __webpack_public_path__ + "static/img/complete.f6a2dabd.svg";